import { AppIntegrationsRepository, LicensesRepository, DevicesRepository, MeRepository } from 'common/repositories/index';
import log from 'common/services/logging/loggers';
import { Session, SessionKeys } from 'common/services/-RFC.session.js';
import { DevicesProcessor } from 'common/repositoryProcessors/index';

const _serviceDependencies = ['$scope', '$timeout', '$state', '$location', '$urlMatcherFactory', 'Util', '$rootScope'];

/**
* @ngdoc service
* @name controllers.Deploy
*
* @description
* Deploy controller
*/
class Deploy {

    /**
     * @param $scope
     * @param $state
     * @param $location
     * @param $urlMatcherFactory
     */
    constructor($scope, $timeout, $state, $location, $urlMatcherFactory, Util, $rootScope) {

        this.currentDeviceOS = window.deviceOs;

        this.$urlMatcherFactory = $urlMatcherFactory;
        this.$timeout = $timeout;
        this.$location = $location;
        this.$scope = $scope;
        this.$state = $state;
        this.Util = Util;
        this.$rootScope = $rootScope;
        this.user = MeRepository.getMyUser();

        this.$scope.AppIntegrationsRepository = AppIntegrationsRepository;
        this.DevicesRepository = DevicesRepository;
        this.LicensesRepository = LicensesRepository;
        this.DevicesProcessor = DevicesProcessor;

        this.$scope.changeWizard = (stateName, params, options) => {

            this.$state
                .go(stateName, params, options)
                .then(() => {

                    this._routes();

                })
                .catch(e => log.log(e));

        };

        this.$scope.showSuccessScreen = (category, deviceType) => {

            const queryParams = this.$location.search();

            if (!queryParams.autoInstall) {

                if (deviceType === 'pc') {

                    if (category === 'download') {

                        this.$scope.dynamicDirectiveTag = '<pc-download-deployment-success />';

                    } else if (category === 'email') {

                        this.$scope.dynamicDirectiveTag = '<pc-email-deployment-success />';

                    }

                } else if (deviceType === 'phone') {

                    if (category === 'email') {

                        this.$scope.dynamicDirectiveTag = '<phone-email-deployment-success />';

                    }

                }

                const updatedInputData = angular.extend({}, this.$scope.inputData, {

                    showSuccessScreen: true,

                });


                this.$scope.inputData = updatedInputData;

            }

        };

        this.$scope.deployOnDeviceSuccess = (device, appId) => {

            this.$scope.inputData = angular.extend({}, this.$scope.inputData, {

                deviceId: device.id,
                appId,
                completedSteps: true,

            });

            if (device.attributes.os === 'osx') {

                // show download modal for osx
                this.$scope.inputData.os = device.attributes.os;
                this.$scope.dynamicDirectiveTag = '<pc-deployment-wizard />';

            } else if (device.attributes.state === 'online') {

                this.$scope.dynamicDirectiveTag = '<online-deployment />';

            } else {

                this.$scope.dynamicDirectiveTag = '<offline-deployment />';

            }

        };

        this._init();

    }

    _init() {

        this._routes();

    }

    _routes() {

        const queryParams = this.$location.search();

        // My Devices
        if (this._isMatching('/dashboard/devices/new/ltb/deploy')) {

            const paramsWithDefaultOs = angular.extend({}, this.$state.params, {
                os: 'windows',
            });

            this.$scope.changeWizard('root.dashboard.devices.ltb.deploy', paramsWithDefaultOs, {
                reload: false,
            });

        } else if (this._isMatching('/dashboard/devices/new/ltb/deploy?os')) {

            const licenses = this.LicensesRepository.getAll();

            if (licenses.length) {

                this.$scope.inputData = {
                    appId: queryParams.appId,
                    licenses,
                    os: queryParams.os,
                    deviceType: this.Util.getDeviceTypeBy(queryParams.os),
                };

                this.$scope.dynamicDirectiveTag = '<paid-deployment-wizard />';
                return;

            }
            const paramsWithDefaultApp = angular.extend({}, this.$state.params, {
                appId: CWCONFIG.defaultDeployedAppId[queryParams.os],
                os: queryParams.os,
            });

            this.$scope.changeWizard('root.dashboard.devices.ltb.deploy', paramsWithDefaultApp, {
                reload: false,
            });

        } else if (this._isMatching('/dashboard/home/new/ltb/deploy?os')) {

            const licenses = this.LicensesRepository.getAll();

            if (licenses.length) {

                this.$scope.inputData = {
                    appId: queryParams.appId,
                    licenses,
                    os: queryParams.os,
                    deviceType: this.Util.getDeviceTypeBy(queryParams.os),
                };

                this.$scope.dynamicDirectiveTag = '<paid-deployment-wizard />';
                return;

            }
            const paramsWithDefaultApp = angular.extend({}, this.$state.params, {
                appId: CWCONFIG.defaultDeployedAppId[queryParams.os],
                os: queryParams.os,
            });

            this.$scope.changeWizard('root.dashboard.home.ltb.deploy', paramsWithDefaultApp, {
                reload: false,
            });

        } else if (this._isMatching('/dashboard/devices/new/ltb/deploy?appId')) {

            const { appId } = queryParams;
            const app = this._checkForApp(appId);

            if (app) {

                this.$scope.inputData = {
                    resourceId: this.$state.params.resourceId,
                    appId,
                };
                this.$scope.dynamicDirectiveTag = '<choose-os-type-deployment-wizard />';

            } else {

                this.Util.closeModal();

            }

        } else if (this._isMatching('/dashboard/devices/new/ltb/deploy?appId&os')) {

            this._showDeployWizard(queryParams);

        } else if (this._isMatching('/dashboard/home/new/ltb/deploy?appId&os')) {

            this._showDeployWizard(queryParams);

        } else if (this._isMatching('/dashboard/devices/:resourceId/tabs/:tab/ltb/deploy?appId') ||
            this._isMatching('/dashboard/devices/:resourceId/tabs/:tab/ltb/deploy?appId?autoInstall')) {

            // Device Details
            const deviceId = this.$state.params.resourceId;
            const device = this.DevicesRepository.getById(deviceId);
            const mobileTypes = ['tablet', 'phone'];

            this.$scope.inputData = {
                appId: queryParams.appId,
                deviceId,
            };

            if (!device) {

                this.Util.closeModal();
                return;

            }

            // Show download modal if device os is osx
            if (device.attributes.os === 'osx' || device.attributes.os === 'windows') {

                queryParams.os = device.attributes.os;
                this._showDeployWizard(angular.extend(
                    queryParams,
                    {
                        autoInstall: queryParams.autoInstall,
                    },
                ));
                return;

            }

            if (mobileTypes.indexOf(device.attributes.type) >= 0) {

                queryParams.os = device.attributes.os;
                this._showDeployWizard(queryParams);
                return;

            }

            // if (device.attributes.state === 'online') {

            //     this.$scope.dynamicDirectiveTag = '<online-deployment />';
            //     return;

            // }

            // this.$scope.dynamicDirectiveTag = '<offline-deployment />';

        } else if (
            this._isMatching('/dashboard/products/:resourceId/ltb/deploy') ||
            this._isMatching('/dashboard/products/:resourceId/ltb/deploy?os&deployType')) {

            // My Products
            if (!this._checkForApp(this.$state.params.resourceId)) {

                this.Util.closeModal();
                return;

            }

            this.$scope.inputData = {
                resourceId: this.$state.params.resourceId,
                appId: this.$state.params.resourceId,
            };

            if (this.$state.params.deployType && this.$state.params.os) {

                angular.extend(this.$scope.inputData, {
                    deployType: this.$state.params.deployType,
                    os: this.$state.params.os,
                });

            }

            const app = AppIntegrationsRepository.getById(this.$scope.inputData.appId);
            this.compatibleDevicesList =
                this.DevicesProcessor.getCompatibleDevices(app.id, app.attributes.prototype);
            if (this.compatibleDevicesList.length === 0) {

                if (this.$state.params.deployType) {

                    // Products
                    this._showDeployWizard(angular.extend(
                        queryParams,
                        {
                            appId: this.$state.params.resourceId,
                            autoInstall: queryParams.autoInstall,
                        },
                    ));

                } else {

                    this.$scope.dynamicDirectiveTag = '<choose-os-type-deployment-wizard />';

                }

            } else {

                this.$scope.dynamicDirectiveTag = '<choose-device-deployment-wizard />';

            }

        } else if (this._isMatching('/dashboard/devices/:resourceId/ltb/deploy?deviceCategory')) {

            this.$scope.inputData = {
                deviceCategory: this.$state.params.deviceCategory,
            };

            this.$scope.dynamicDirectiveTag = '<choose-os-type-wizard />';

        } else if (this._isMatching('/dashboard/home/:resourceId/ltb/deploy?deviceCategory')) {

            this.$scope.inputData = {
                deviceCategory: this.$state.params.deviceCategory,
            };

            this.$scope.dynamicDirectiveTag = '<choose-os-type-wizard />';

        } else if (
            this._isMatching('/dashboard/products/:resourceId/ltb/deploy?deviceId') ||
            this._isMatching('/dashboard/products/:resourceId/ltb/deploy?deviceId&autoInstall') ||
            this._isMatching('/dashboard/products/:resourceId/ltb/deploy?deviceId&deployType')
        ) {

            // Products
            if (queryParams.deviceId === 'new') {

                this.$scope.inputData = {
                    resourceId: this.$state.params.resourceId,
                    appId: this.$state.params.resourceId,
                    deployType: this.$state.params.deployType,
                };

                if (this.$state.params.deployType) {

                    angular.extend(this.$scope.inputData, {
                        deployType: this.$state.params.deployType,
                    });

                }

                this.$scope.dynamicDirectiveTag = '<choose-os-type-deployment-wizard />';

            } else {

                this.Util.closeModal();

            }

        } else if (
            this._isMatching('/dashboard/products/:resourceId/ltb/deploy?deviceId&os') ||
            this._isMatching('/dashboard/products/:resourceId/ltb/deploy?deviceId&os&autoInstall')
        ) {

            // Products
            this._showDeployWizard(angular.extend(
                queryParams,
                { appId: this.$state.params.resourceId, autoInstall: queryParams.autoInstall },
            ));

        } else if (
            // My Subscriptions
            this._isMatching('/dashboard/subscriptions/tabs/:tab/:resourceId/ltb/deploy?deviceId&appId') ||
            this._isMatching('/dashboard/subscriptions/tabs/:tab/:resourceId/ltb/deploy?deviceId&appId&autoInstall')) {

            const deploymentAppId = Session.getValue(SessionKeys.SubscriptionDeployAppId);

            if (queryParams.deviceId === 'new') {

                this.$scope.inputData = {
                    resourceId: this.$state.params.resourceId,
                    appId: this.$state.params.appId,
                };
                this.$scope.dynamicDirectiveTag = '<choose-os-type-deployment-wizard />';

            } else if (deploymentAppId) {

                const license = this.LicensesRepository.getLicenseByAppId(deploymentAppId);
                const activationCode = this.Util.deepFind(license, 'relationships.activation-code.data.id');
                const matchingOS =
                    this.DevicesProcessor.getDeployOSfor(deploymentAppId, this.currentDeviceOS)
                    || null;
                const appToDeploy = deploymentAppId;

                if (license) {

                    const authExtraUrlParams =
                        Session.getValue(SessionKeys.ExtraUrlParams);
                    const queryParameters = authExtraUrlParams.substring(authExtraUrlParams.indexOf('?'));
                    const deployQueryParams = _.isEmpty(this.$location.search()) ?
                        this.Util.getParams(queryParameters) :
                        this.$location.search();
                    const deployPayload = angular.extend(
                        {},
                        {
                            ltb: 'deploy',
                            resourceId: activationCode,
                            deviceId: 'new',
                            appId: appToDeploy,
                            os: matchingOS,
                            tab: 'plans',
                        },
                        deployQueryParams,
                    );

                    // if we receive the autoInstall attribute and it's set to true
                    // we also check if we have an os on which to install the product
                    const canBeAutoInstalled =
                        deployPayload.autoInstall &&
                        deployPayload.autoInstall === 'true' &&
                        deployPayload.os !== null;

                    if (!canBeAutoInstalled || appToDeploy === 'adwp1') {

                        deployPayload.autoInstall = false; // disable autoInstall

                        // set a default os for which to display the modal
                        // first in the list of compatible oses for the product
                        const supportedOs =
                            AppIntegrationsRepository.getSupportedOs(deploymentAppId);
                        deployPayload.os = supportedOs && supportedOs.length > 0 && supportedOs[0];

                    }

                    this._showDeployWizard(angular.extend(deployPayload));
                    Session.clear(SessionKeys.SubscriptionDeployAppId);

                } else {

                    this.Util.closeModal();

                }

            } else {

                this.Util.closeModal();

            }

        } else if (
            // My Subscriptions
            this._isMatching('/dashboard/subscriptions/tabs/:tab/:resourceId/ltb/deploy?deviceId&appId&os') ||
            this._isMatching('/dashboard/subscriptions/tabs/:tab/:resourceId/ltb/deploy?deviceId&appId&os&autoInstall')) {

            const appData = AppIntegrationsRepository.getById(queryParams.appId);
            const appType = this.Util.deepFind(appData, 'attributes.type');

            if (appType === 'bundle' && (queryParams.os === 'android' || queryParams.os === 'ios')) {

                // Send only the current license
                const licenses = [];
                if (!this.LicensesRepository.getLicenseBy(this.$state.params.resourceId)) {

                    // Trial
                    licenses[0] =
                        this.LicensesRepository.getLicenseById(this.$state.params.resourceId);

                } else {

                    licenses[0] =
                        this.LicensesRepository.getLicenseBy(this.$state.params.resourceId);

                }

                this.$scope.inputData = {
                    licenses,
                    os: queryParams.os,
                    deviceType: this.Util.getDeviceTypeBy(queryParams.os),
                };

                this.$scope.dynamicDirectiveTag = '<paid-deployment-wizard />';

            } else {

                this._showDeployWizard(angular.extend(
                    queryParams,
                    { resourceId: this.$state.params.resourceId },
                ));

            }

        } else if (this._isMatching('/dashboard/apps/:resourceId/devices/:deviceId/ltb/deploy?appId')) {

            // Sidebar apps page deploy

            if (!this._checkForApp(queryParams.appId)) {

                this.Util.closeModal();
                return;

            }

            if (this.$state.params.deviceId === 'new') {

                this.$scope.inputData = {
                    resourceId: this.$state.params.resourceId,
                    appId: queryParams.appId,
                };
                this.$scope.dynamicDirectiveTag = '<choose-os-type-deployment-wizard />';

            } else {

                this.Util.closeModal();

            }

        } else if (
            this._isMatching('/dashboard/apps/:resourceId/devices/:deviceId/ltb/deploy?appId&os')) {

            this._showDeployWizard(angular.extend(queryParams, { appId: queryParams.appId }));

        } else if (
            this._isMatching('/dashboard/store/:resourceId/ltb/deploy?deviceId&appId') ||
            this._isMatching('/dashboard/store/:resourceId/ltb/deploy?deviceId&autoInstall')
        ) {

            // store
            if (queryParams.deviceId === 'new') {

                this.$scope.inputData = {
                    resourceId: this.$state.params.resourceId,
                    appId: this.$state.params.appId,
                };
                this.$scope.dynamicDirectiveTag = '<choose-os-type-deployment-wizard />';

            } else {

                this.Util.closeModal();

            }

        } else if (
            this._isMatching('/dashboard/store/:resourceId/ltb/deploy?deviceId&os') ||
            this._isMatching('/dashboard/store/:resourceId/ltb/deploy?deviceId&os&autoInstall') ||
            this._isMatching('/dashboard/store/:resourceId/ltb/deploy?deviceId&appId&os&autoInstall')
        ) {

            // store
            this._showDeployWizard(angular.extend(
                queryParams,
                { appId: this.$state.params.appId, autoInstall: queryParams.autoInstall },
            ));

        }

        if (this.$scope.inputData && !this.$scope.inputData.emails) {

            this.$scope.inputData = angular.extend(
                this.$scope.inputData,
                { emails: [this.user.attributes.email] },
            );

        }

        // Save the license id or the activation code on $rootScope
        // to be able to go back if the user selects ios or android
        // from deploy on another device modal on subscriptions
        if (this.$state.params.resourceId.length >= 25
            || this.$state.params.resourceId.length === 20) {

            this.$rootScope.State.deploySteps[0] = this.$state.params;

        }

        // currentAppId is used for deploy modal breadcrumb
        // it creates a relationship between a bundle and a product
        if (this.$rootScope.State.deploySteps.length > 0) {

            if (this.$rootScope.State.deploySteps[0].appId !== this.$state.params.appId) {

                this.$rootScope.State.deploySteps[0].currentAppId = this.$state.params.appId;

            }

        }

    }

    _isMatching(pattern) {

        const urlMatcher = this.$urlMatcherFactory.compile(pattern);

        return this.$location.url() === urlMatcher.format(angular.extend(
            this.$state.params,
            this.$location.search(),
        ));

    }

    _checkForApp(appId) {

        const app = AppIntegrationsRepository.getById(appId);
        const hasApp = !!app;

        return hasApp;

    }

    _showDeployWizard(queryParams) {

        this.$scope.inputData = {
            appId: queryParams.appId,
            resourceId: queryParams.appId,
            os: queryParams.os,
            autoInstall: queryParams.autoInstall,
        };

        if (!this._checkForApp(queryParams.appId)) {

            this.Util.closeModal();
            return;

        }

        if (queryParams.os === 'webapp') {

            this.$scope.dynamicDirectiveTag = '<web-app-deployment />';
            return;

        }

        if (queryParams.os === 'windows' ||
            queryParams.os === 'osx') {

            this.$scope.dynamicDirectiveTag = '<pc-deployment-wizard />';
            return;

        }

        if (queryParams.os === 'android' ||
            queryParams.os === 'ios') {

            this.$scope.dynamicDirectiveTag = '<phone-deployment-wizard />';
            return;

        }

        this.Util.closeModal();

    }

}

_serviceDependencies.push(Deploy);

angular.module('controllers')
    .controller('Deploy', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/deployment/deploy.js